import { DiagnosticsData } from '../../../shared/types/diagnosticsData.ts';
import { PageDisplayOption } from '../../types/pageDispalyOptions.ts';
import { PageDisplaySettings } from './pageDisplaySettings.tsx';
import { ServerHealth } from './serverHealth.tsx';

interface Props {
    diagnosticsData: DiagnosticsData | undefined;
    pageDisplay: PageDisplayOption;
    page: number;
    setPageDisplay: (option: PageDisplayOption) => void;
    isSingleView?: boolean;
    page1StartColumn?: number;
}

export function HealthAndControls({ diagnosticsData, pageDisplay, page, setPageDisplay, isSingleView = false, page1StartColumn = 1 }: Props) {
    const gridRow = isSingleView ? '6 / span 1' : page === 1 ? '6 / span 1' : '1 / span 1';
    const gridColumn = isSingleView ? page1StartColumn + 5 : page === 1 ? 'col6' : 'col2';

    return (
        <div
            style={{
                gridColumn: gridColumn,
                gridRow: gridRow,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-evenly',
                alignItems: 'center',
            }}
        >
            <ServerHealth diagnosticsData={diagnosticsData} />
            <PageDisplaySettings pageDisplay={pageDisplay} setPageDisplay={setPageDisplay} />
        </div>
    );
}